import styled from "styled-components";
import theme from "~/styles/theme";

export const ContentCard = styled.div`
  background: ${theme.palette.neutral.primary.light};
  width: 100%;
  padding: 40px;
  h3,
  p {
    color: ${theme.palette.brand.primary.dark};
  }
`;

export const AccountCard = styled.div`
  width: 100%;
  border: 2px solid ${theme.palette.brand.primary.key};
  padding: 24px;
  margin-bottom: 32px;
  text-align: left;
  border-radius: 16px;
  h3,
  p {
    color: ${theme.palette.neutral.primary.key};
  }
  @media (min-width: ${theme.breakpoints.values.md}px) {
    margin-bottom: 24px;
  }
  .title {
    font-family: ${theme.typography.fontFamilyRegular};
    color: ${theme.palette.neutral.primary.key};
    font-weight: 500;
  }
`;

export const CardSeparator = styled.div`
  border-bottom: 2px solid ${theme.palette.brand.primary.key};
`;

export const CardLink = styled.div`
  cursor: pointer;

  p {
    margin-right: 8px;
    text-decoration: underline;
  }

  strong {
    margin-right: 8px;
  }
`;

export const CardAbstract = styled.div`
  margin-top: 32px;
  flex-wrap: wrap;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    display: flex;
    justify-content: space-between;
  }

  > div {
    display: flex;
    flex-direction: column;
    flex: 1;
    margin-bottom: 24px;

    @media (min-width: ${theme.breakpoints.values.md}px) {
      margin-bottom: 0;
      max-width: 175px;
      width: 100%;
      flex: auto;
    }

    span {
      font-size: 13px;
    }

    strong {
      color: ${theme.palette.neutral.primary.key};
    }

    // &:last-child {
    //   margin-top: 32px;
    // }
  }
`;

export const TitleHolder = styled.div`
  text-align: center;
  h3 {
    font-family: ${theme.typography.fontFamilyRegular};
    color: ${theme.palette.neutral.primary.key};
    font-weight: 600;
  }
  @media (min-width: ${theme.breakpoints.values.md}px) {
    text-align: left;
  }
`;

export const UpdatePasswordCard = styled.div`
  padding: 24px;
  background: ${theme.palette.neutral.primary.light};
  text-align: left;
  position: relative;
  width: 100%;
  border-radius: 16px;

  h3 {
    color: ${theme.palette.neutral.primary.key};
    margin-bottom: 8px;
    font-weight: 700;
  }

  p {
    color: ${theme.palette.neutral.primary.key};
  }

  a {
    span {
      font-weight: 400;
      color: ${theme.palette.neutral.primary.key} !important;
    }
  }

  @media (min-width: ${theme.breakpoints.values.md}px) {
    padding: 24px;
  }
`;

export const UpdatePasswordActions = styled.div`
  @media (min-width: ${theme.breakpoints.values.md}px) {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
    flex-direction: column;
  }

  p {
    margin-bottom: 16px;
    font-family: ${theme.typography.fontFamilyRegular};
    color: ${theme.palette.neutral.primary.key};
  }

  a {
    color: ${theme.palette.brand.primary.key} !important;
    text-align: right;
    display: flex;
    align-items: center;
    text-decoration: underline;

    span {
      color: ${theme.palette.brand.primary.key} !important;
    }

    svg {
      margin-left: 8px;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .update-password {
    color: #0D5BA8;
    cursor: pointer;
    text-decoration: underline;
  }
`;

export const CardContact = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-direction: column;

  > div {
    display: flex;
    width: 100%;
    justify-content: space-between;
    flex-direction: column;
    margin-top: 32px;

    @media (min-width: ${theme.breakpoints.values.md}px) {
      flex-direction: row;

      
      &:nth-child(1) {
        border-bottom: 1px solid ${theme.palette.brand.primary.key};
        padding-bottom: 30px;
        /* border-radius: 16px; */

        @media (min-width: ${theme.breakpoints.values.md}px) {
          padding-bottom: 0;
        }

        > div {
          @media (min-width: ${theme.breakpoints.values.md}px) {
            margin-bottom: 32px;
          }
        }
      }
    }

  }
`;

export const CardLinkHolder = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  align-items: flex-end;
  margin-top: 32px;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    flex-direction: row;
    margin-top: 32px;
  }

  > div {
    &:nth-child(1) {
      margin-bottom: 31px;

      @media (min-width: ${theme.breakpoints.values.md}px) {
        margin-bottom: 0;
      }
    }
  }
`;

export const IconMargin = styled.span`
  margin-right: 8px;
`;

export const ContactUs = styled.div`
  margin-top: 24px;

  p {
    font-family: ${theme.typography.fontFamilyRegular};
    color: ${theme.palette.neutral.primary.key};
    font-size: 16px;
  }

  a {
    font-size: 16px;
    font-family: ${theme.typography.fontFamily};
    color: ${theme.palette.brand.primary.key};
    letter-spacing: 0;
    line-height: 24px;
    font-weight: 700;
    white-space: nowrap;
  }
`;

export const ResendEmail = styled.div`
  font-family: ${theme.typography.fontFamily};
  color: ${theme.palette.neutral.primary.key};
  @media (min-width: ${theme.breakpoints.values.md}px) {
    margin-right: 24px;
  }
`;
